import * as React from 'react';

export const StartIconSvg = () => (
  <svg viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 4.03589L7.5 6.53589V1.53589L10.5 4.03589Z"
      fill="currentColor"
    />
    <path d="M8.5 3.57184V4.57184H2.5V3.57184H8.5Z" fill="currentColor" />
    <path
      d="M1 7.07178H0L2.62267e-07 1.07178L1 1.07178L1 7.07178Z"
      fill="currentColor"
    />
  </svg>
);
